import React from 'react';
import { Icon } from './Icon.js';
export const IconCompassFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6,0C2.691,0,0,2.691,0,6s2.691,6,6,6,6-2.691,6-6S9.309,0,6,0Zm2.665,3.688l-1.232,2.875c-.168.391-.479.703-.87.87l-2.875,1.232c-.223.095-.448-.13-.353-.353l1.232-2.875c.168-.391.479-.703.87-.87l2.875-1.232c.223-.096.448.13.353.353Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCompassFill12.js.map